import styled from "styled-components"
import { when } from "utils"

export const Container = styled.div`
  background: #fff;
  box-shadow: 0 2px 7px rgba(145, 145, 145, 0.35);
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;
`

export const Content = styled.div`
  padding: 0 2rem;
  overflow: hidden;
  transition: height 0.3s ease-out;

  h3 {
    font-size: 2.5rem;
    line-height: 3.2rem;
  }

  p {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }
`

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;

  > :first-child {
    color: #7b7240;
    font-size: 1.3rem;
    text-transform: uppercase;
    font-weight: 500;
  }
`

export const Arrow = styled.div`
  border: solid #777;
  border-width: 0 0.3rem 0.3rem 0;
  display: inline-block;
  padding: 0.5rem;
  transform: rotate(45deg);
  transition: all 0.25s ease-in-out;
  flex-shrink: 0;

  ${when("expanded")`
    transform: rotate(-135deg);
  `}
`

export const List = styled.ol`
  ::before {
    display: block;
    content: "Lessons";
    text-transform: uppercase;
    font-size: 1.5rem;
    padding-bottom: 1.5rem;
    font-weight: 500;
  }

  margin: 0;
  padding: 0;
  list-style: none;

  li {
    font-size: 1.6rem;
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 0.5rem;
    margin-bottom: 1.5rem;
    font-weight: 500;
  }
`

export const ReadMore = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-weight: 500;
  font-size: 1.6rem;
  color: rgb(128 128 128);
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgb(255, 255, 255) 50%,
    rgb(255, 255, 255) 0px
  );
  padding: 6rem 2rem 1.5rem;
  border-radius: 0.5rem;

  ${when("expanded")`
    background-image: none;
  `}
`
